import { memo } from 'react';
import { Tab, TabProps, Tabs, TabsProps, styled } from '@mui/material';
import HeaderTabNavigation from '../../../molecules/HeaderTabNavigation';
import { TabsConfig } from '../../../../hooks/useHeaderTabs';
import SwipeableLogo from '../../../icons/SwipeableLogo';
import { GOLA_HEADER_HEIGHT } from '../../../../config/skinRegistry/configs';

const GOLA_CONFIG: TabsConfig = {
  mobile: {
    common: [],
    auth: [
      { label: 'inPlay', value: '/in-play' },
      { label: '', value: '/sports', icon: <SwipeableLogo size='small' /> },
      { label: 'bets', value: '/my-bets' },
    ],
    public: [
      { label: 'sports', value: '/sports' },
      { label: 'inPlay', value: '/in-play' },
      { label: 'casino', value: '/casino' },
    ],
  },
  desktop: {
    common: [
      { label: 'sports', value: '/sports' },
      { label: 'inPlay', value: '/in-play' },
      { label: 'casino', value: '/casino' },
    ],
    auth: [
      {
        label: 'myBets',
        value: '/my-bets',
      },
    ],
    public: [],
  },
};

const GolaStyledTabs = styled(({ indicatorWidth, ...props }: TabsProps & { indicatorWidth?: number }) => (
  <Tabs
    {...props}
    slotProps={{
      indicator: {
        children: <span className='MuiTabs-indicatorSpan' />,
      },
    }}
  />
))(({ theme, indicatorWidth }) => ({
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, 0)',
  overflow: 'visible',
  '& .MuiTabs-scroller': {
    overflow: 'visible !important',
  },
  '& .MuiTabs-indicator': {
    background: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    height: 2,
    bottom: 0,
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: indicatorWidth ?? '100%',
    width: '100%',
    backgroundColor: theme.palette.secondary.main,
  },
  '& .MuiTab-root': {
    overflow: 'visible',
    minWidth: 12,
    [theme.breakpoints.down('md')]: {
      padding: 8,
      ...theme.typography.body2,
    },
    opacity: 1,
    color: theme.palette.neutral[25],
    '&.Mui-selected': {
      color: theme.palette.neutral[50],
    },
    '&:not(.Mui-selected):hover': {
      color: theme.palette.secondary.main,
    },
  },
}));

const GolaStyledTab = styled((props: TabProps) => <Tab disableRipple {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  minHeight: GOLA_HEADER_HEIGHT,
  height: GOLA_HEADER_HEIGHT,
  textTransform: 'none',
  whiteSpace: 'nowrap',
}));

export const GolaHeaderNavigation = memo(() => (
  <HeaderTabNavigation config={GOLA_CONFIG} TabsComponent={GolaStyledTabs} TabComponent={GolaStyledTab} />
));

export default GolaHeaderNavigation;
